import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import hospitalLogo from "../assets/hospital_logo.png";

function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Close menu on ESC key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav className={`navbar ${isOpen ? "menu-open" : ""}`}>
        <Link to="/" className="navbar-brand-link" onClick={closeMenu}>
          <div className="hospital-brand">
            <img src={hospitalLogo} alt="Sai Hospital Logo" className="hospital-brand-logo" />
            <span className="hospital-brand-title">
              Sai Homoeopathic Clinic And Multispeciality Centre
            </span>
          </div>
        </Link>

        <button
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          type="button"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <div className={`nav-links ${isOpen ? "active" : ""}`}>
          <Link
            to="/"
            className={`nav-link-item ${isActive("/") ? "active" : ""}`}
            onClick={closeMenu}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            <span>Home</span>
          </Link>

          <Link
            to="/about"
            className={`nav-link-item ${isActive("/about") ? "active" : ""}`}
            onClick={closeMenu}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            <span>About Us</span>
          </Link>

          <Link
            to="/facility"
            className={`nav-link-item ${isActive("/facility") ? "active" : ""}`}
            onClick={closeMenu}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
            <span>Facilities</span>
          </Link>

          <Link
            to="/contact"
            className={`nav-link-item ${isActive("/contact") ? "active" : ""}`}
            onClick={closeMenu}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            <span>Contact</span>
          </Link>

          <Link
            to="/appointment"
            className={`nav-link-item appointment-nav-btn ${isActive("/appointment") ? "active" : ""}`}
            onClick={closeMenu}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            <span>Book Appointment</span>
          </Link>

          {!["/dashboard"].includes(location.pathname) && (
            <Link
              to="/login"
              className="admin-btn"
              onClick={closeMenu}
            >
              <svg className="nav-icon admin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>Admin Portal</span>
            </Link>
          )}
        </div>
      </nav>

      {/* Backdrop overlay for mobile drawer */}
      {isOpen && <div className="nav-backdrop" onClick={closeMenu} aria-hidden="true" />}
    </>
  );
}

export default Navbar;